export const SEVERITIES = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
} as const
export const SEVERITIES_ICONS = {
  [SEVERITIES.CRITICAL]: 'severity-critical',
  [SEVERITIES.HIGH]: 'severity-high',
  [SEVERITIES.MEDIUM]: 'severity-medium',
  [SEVERITIES.LOW]: 'severity-low',
} as const
